export default {
      id: "shape-bottom-2000-blanc-usage",
      viewBox: "0 0 2000 206.42",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#shape-bottom-2000-blanc-usage",
      toString: function () {
        return this.url;
      }
    }